import { combineReducers } from 'redux';

import activityReducer from './activity/activity.reducer';
import browserReducer from './browser/browser.reducer';
import coursesReducer from './course/course.reducer';
import institutionReducer from './institution/institution.reducer';
import userReducer from './user/user.reducer';
import { USER_LOGOUT } from './general/general.types';

const appReducer = combineReducers({
  activity: activityReducer,
  browser: browserReducer,
  courses: coursesReducer,
  institution: institutionReducer,
  user: userReducer,
});

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
